<template>
    <div id="affiliate-banner" />
    <sembo-auth ref="authRef" />
    <sembo-header
        class="company-header"
        :enable-side-menu="enableSideMenu"
        :disable-auth-button="disableAuthButton" />
</template>

<script lang="ts">
    import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
    import { updateCurrentSessionCart } from '@/api/Cart/cart.helpers';
    import { loadCart } from '@/helpers/cartLoad';
    import { getErrorMessage, handleCustomError } from '@/config/errorHandling';
    import {
        isBookingPage,
        isBookingsPage,
        isCheckoutPage,
        isPaymentPage,
    } from '@/helpers/url';

    export default defineComponent({
        name: 'CompanyHeader',
        setup() {
            const authRef = ref<HTMLElement | undefined>();
            const shouldReloadCart = computed(() => isCheckoutPage());
            const enableSideMenu = computed(() => isBookingPage() || isBookingsPage());
            const disableAuthButton = computed(() => isPaymentPage());

            async function onUserLogin() {
                if (!shouldReloadCart.value) return;

                try {
                    updateCurrentSessionCart();
                    await loadCart();
                } catch (err) {
                    handleCustomError(`[CompanyHeader] onUserLogin: ${getErrorMessage(err)}`);
                }
            }

            onMounted(() => {
                if (authRef.value) {
                    window.addEventListener('semboUserLoggedIn', onUserLogin);
                }
            });

            onUnmounted(() => {
                if (authRef.value) {
                    window.removeEventListener('semboUserLoggedIn', onUserLogin);
                }
            });

            return {
                authRef,
                disableAuthButton,
                enableSideMenu,
            };
        },
    });
</script>

<style scoped lang="scss">
    @forward 'CompanyHeader';
</style>
